import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

Sentry.init({
  dsn: "https://2106b1395e0541a8a1e2b51fce77bcaf@o425585.ingest.sentry.io/6005438",
  integrations: [new Integrations.BrowserTracing()],
  release: "pocketbits_website@" + window.appVersion,
  ignoreErrors: [
    "Unhandled Rejection (TypeError): Failed to fetch",
    "Cannot read properties of null (reading 'onclose')",
    "Cannot read properties of null (reading 'display')",
    "An error occurred while fetching the data.",
    "Non-Error promise rejection captured with keys: data, status, success",
    "Non-Error promise rejection captured with value: Timeout",
    "Cannot read properties of null (reading 'notification_prompt_delay')",
    "null is not an object (evaluating 'beamer_config.display')",
    "null is not an object (evaluating 'beamer_config.onclose')",
    "Cannot read property 'display' of null",
    "Cannot read property 'removeEventListener' of undefined",
    "API.JS :: user not found",
    'SecurityError: Permission denied to access property "dispatchEvent" on cross-origin object',
    "Non-Error promise rejection captured with keys: isCanceled",
    "Failed to fetch",
    "ResizeObserver loop limit exceeded",
    "AbortController is not defined",
    "InvalidStateError: IDBDatabase.transaction: Can't start a transaction on a closed database",
    "InvalidStateError: Failed to execute 'transaction' on 'IDBDatabase': The database connection is closing.",
    "AbortError: The user aborted a request.",
    "fullscreen error",
    "A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
    "Network Error",
  ],
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
  enabled: process.env.NODE_ENV !== "development",
});

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorkerRegistration.register();
